import emojiData from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React from "react";
EmojiPicker.defaults = {
    previewPosition: "none",
};
/**
 * A searchable emoji picker wrapping emoji-mart, themed for light or dark
 * mode. Use it wherever the user picks an emoji (reactions, avatars),
 * typically inside a popover; it isolates Sparkle's design tokens so the
 * picker's own theming is preserved.
 * @summary Emoji-mart picker wrapper.
 */
function EmojiPicker({ data = emojiData, onEmojiSelect, previewPosition, theme, }) {
    return (React.createElement("div", { style: {
            "--color-border": "initial",
            "--color-border-over": "initial",
        } },
        React.createElement(Picker, { theme: theme, previewPosition: previewPosition, data: data, onEmojiSelect: onEmojiSelect })));
}
export { EmojiPicker, emojiData as DataEmojiMart };
//# sourceMappingURL=EmojiPicker.js.map